var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu',{attrs:{"restaurant":_vm.restaurant,"token":_vm.token,"customerprop":_vm.customerprop,"app_locale":_vm.app_locale,"has_free_delivery":_vm.has_free_delivery,"should_upsell":_vm.should_upsell,"upsell_fee":_vm.upsell_fee}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }